import React from 'react'
import { Button } from '@/components/ui/button'
import { UserPlus } from 'lucide-react'

interface UsersHeaderProps {
  onInviteClick: () => void
}

export function UsersHeader({ onInviteClick }: UsersHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold">User Management</h1>
        <p className="text-gray-600">Manage user accounts, roles, and permissions</p>
      </div>
      <Button onClick={onInviteClick} aria-label="Invite User">
        <UserPlus className="h-4 w-4 mr-2" />
        Invite User
      </Button>
    </div>
  )
}
